export enum ChannelOnboardingStep {
  waitingForMembership,
  selectCommunities,
  welcomeToChannel,
}
